
import { useIntersectionObserver } from "../../hooks/useIntersectionObserver";

const ValuesSection = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <div className="w-full bg-[#104B60] py-16 mb-16">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 transition-all duration-1000 transform ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <h2 className="text-6xl font-charter font-medium mb-12 text-[#FAF9F8] text-center">What sets us apart</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Simplicity first</h3>
            <p className="text-[#104B60]">
              Managing ad spend shouldn't be a headache. Our intuitive platform removes complexity, consolidating multiple ad channels into a seamless experience - so you can focus on growth, not spreadsheets.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Budget beyond reporting</h3>
            <p className="text-[#104B60]">
              Unlike traditional analytics tools, we don't just show you data - we help you plan, track, and control your ad spend. Our budgeting and planning features ensure every marketing dollar is working toward your goals.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Plan ahead, spend smarter</h3>
            <p className="text-[#104B60]">
              Using our calendar-based planning, you can schedule upcoming promotions, allocate budgets in advance, and stay ahead of your marketing strategy - ensuring a proactive rather than reactive approach to ad spend.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Time is money</h3>
            <p className="text-[#104B60]">
              We automate tedious tasks so you don't waste hours tracking performance manually. Real-time insights, dynamic budgeting, and intuitive planning tools keep you efficient and in control.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Affordability</h3>
            <p className="text-[#104B60]">
              Great ad management shouldn't come with an enterprise-level price tag. We provide an affordable, all-in-one solution that delivers powerful budgeting and planning tools at a price that fits growing businesses.
            </p>
          </div>
          <div className="rounded-2xl p-6 bg-[#FAF9F8]">
            <h3 className="text-2xl font-charter font-medium mb-4 text-[#104B60]">Built for growth</h3>
            <p className="text-[#104B60]">
              Your success is our priority. Whether you're launching your first campaign or scaling your brand, our platform adapts with you - ensuring flexibility, efficiency, and smarter spending at every stage.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValuesSection;
